import { AddToCartItemModel } from 'models';

export class QueryHelper {

    public parseCartItemsFromQuery(search: string): AddToCartItemModel[] {
        const params = new URLSearchParams(search);
        const result: AddToCartItemModel[] = [];

        params.forEach((qty, sku) => {
            const item = this.toCartItem(sku, qty);
            if (item) {
                result.push(item);
            }
        });

        return result;
    }

    private toCartItem(sku: string, qty: string): AddToCartItemModel | null {
        const quantity = Number(qty);

        if (!sku || !quantity || quantity <= 0) {
            return null;
        }

        return { productCode: sku, quantity };
    }
}

export const queryHelper = new QueryHelper();
